import React, { memo } from 'react';
import { SvgUniqueID } from '@financial/svg-manager';

const IconCheck = /*#__PURE__*/memo(_ref => {
  let {
    fill = '#BFBFBF',
    width = '100%',
    height = '100%',
    viewBox = '0 0 10 8',
    id,
    style = {}
  } = _ref;
  return /*#__PURE__*/React.createElement(SvgUniqueID, {
    id: id
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: viewBox,
    style: style
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgicon_a",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgicon_b",
    transform: "translate(-24.000000, -486.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgicon_c",
    transform: "translate(20.000000, 481.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgicon_d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.37438961,12.6233766 C7.22643457,12.6238682 7.08427488,12.5658953 6.97885714,12.4620779 L4.25431169,9.76698701 C4.14971834,9.66391745 4.09082861,9.52320744 4.09082861,9.37636364 C4.09082861,9.22951983 4.14971834,9.08880982 4.25431169,8.98574026 C4.47352401,8.76981606 4.825463,8.76981606 5.04467532,8.98574026 L7.37438961,11.2888052 L12.9546234,5.77168831 C13.1738357,5.55576412 13.5257747,5.55576412 13.744987,5.77168831 C13.8497565,5.87466328 13.9087686,6.0154087 13.9087686,6.16231169 C13.9087686,6.30921468 13.8497565,6.4499601 13.744987,6.55293506 L7.76992208,12.4620779 C7.6646181,12.5661521 7.52244454,12.6243827 7.37438961,12.6240791",
    id: "Path",
    fill: fill
  })))))));
});

export { IconCheck as default };
